<template>
  <v-col lg="6">
    <br/><br/>
    <v-container fluid>
      <h1 class="mx-1">New booking or quote </h1>
      <p>Enter your waste address in the field below </p>
      <v-row v-if="showBtnLocation">
        <v-col align="start" no-gutters>
          <button class="white--text primary" 
          style="padding: 10px 20px 10px 20px; border-radius: 30px;"
          @click="autoLocation()"
          > Use my current location? </button>
      </v-col>
      </v-row>
      <v-row>
        <v-col>
        <vuetify-google-autocomplete
            filled
            append-icon="mdi-map-marker"
            class="location"
            id="location"
            ref="location"
            type="address"
            :enable-geolocation="true"
            placeholder="Your waste address..."
            v-on:placechanged="locationChange"
            @input="showBtnLocation=true"
            v-model="capturedAddress"
            country="za"
            :disabled="loading"
        >

        </vuetify-google-autocomplete>
        </v-col>
      </v-row>
      <v-row v-if="this.show">
        <v-col xs="16" sm="16" md="3">
          <v-text-field
          type="number"
          label="Postal Code"
          v-model="postCode"
          @change="checkPostalCode"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row justify="center" class="mx-1">
        <v-col align="center">
          <v-btn
            block
            height="55"
            style="border-radius: 30px;"
            v-bind:disabled="!canProceed"
            v-on:click="proceed"
            color="primary"
        >Continue</v-btn>
        </v-col> 
      </v-row>
    </v-container>
  </v-col>
</template>

<script>
export default {
  name: "Address",
  props: {
      locationChangeCallback: Function
  },
  data () {
    return {
      canProceed: false,
      location: {},
      capturedAddress: '',
      postCode: '',
      show: false,
      loading: false,
      showBtnLocation: false
    }
  },
  methods: {
    autoLocation(){
      //find user's location automatically
      this.canProceed = false;
      this.loading = true;
      this.capturedAddress = 'Loading ...';
      if(navigator.geolocation){
        navigator.geolocation.getCurrentPosition((location) => {
          let apikey = 'AIzaSyB2xcq18UZ60nYqMNnU4E6Mv7nhrEjxAXo';
          fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${location.coords.latitude},${location.coords.longitude}&key=${apikey}`)
          .then(response => response.json())
          .then(data => {
            // Check if the request was successful and has results
            if (data.status === 'OK' && data.results.length > 0) {
              const address = data.results[0].formatted_address;
              this.capturedAddress = address;
              this.canProceed = true;
              let postalCode = data.results[0].address_components;
              let postCode = postalCode.find((code) => code.types.includes('postal_code'));
              if(postCode){
                this.postCode = postCode.long_name;
              }
              else{
                this.show = true;
                this.loading = false;
                this.showBtnLocation = false;
              }
              
            } else {
              alert('Unable to retrieve your location. Please allow Dash Waste to use your location');
              this.loading = false;
              this.showBtnLocation = false;
            }
          })
          .catch(error => {
            alert('Error fetching location');
            console.error('Error fetching address:', error);
            this.loading = false;
            this.showBtnLocation = false;
          });
          
        }, (error) => {
          console.log(error);
          alert('Unable to retrieve your location. Please allow Dash Waste to use your location');
          this.$router.go();
        }) 
      }
      else{
        alert('Unable to retrieve your location. Please allow Dash Waste to use your location');
        this.$router.go();
      }
    },
    locationChange(to) {
        this.canProceed = true;
        this.location = to;
        if (this.location.postal_code){
          this.show = false;
        }
        else{
          this.show = true;
        }
    },
    checkPostalCode(){
      if(this.postCode == '' || !this.postCode){
        alert('Please enter the post code for your address');
        this.canProceed = false;
      }
      else{
        this.canProceed = true;
      }
    },
    async proceed() {
      if (this.capturedAddress == '') {
        alert('Please enter your address');
        this.canProceed = false;
        return;
      }
      if (this.capturedAddress.length < 10) {
        alert('Please enter correct address');
        this.canProceed = false;
        return;
      }
      if (!this.location.postal_code && this.postCode.length != 4){
        this.canProceed = false;
        alert('Please enter correct post code for your address');
        return;
      }
      else{
        this.canProceed = true;
        this.locationChangeCallback(this.location, this.capturedAddress, this.postCode);
      }
    }
  },
  mounted(){
    this.$nextTick(() => {
      let icon = this.$refs.location?.$el.querySelector(".v-input__icon .mdi-map-marker");
      let input = this.$refs.location?.$el.querySelector("input");
      
      if (icon) {
        icon.classList.add("bounce");
      }
      if (input && this.capturedAddress !== '') {
        input.addEventListener("focus", () => {
          icon.classList.remove("bounce");
        });

        input.addEventListener("blur", () => {
          icon.classList.add("bounce");
        });
      }
    })
  }
}
</script>
<style>
/** Global style for the bounce effect */
@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-15px);
  }
}

.bounce {
  animation: bounce 1.5s infinite;
}
</style>
<style scoped>
.location{
  font-size: 23px;

}

</style>